export default __webpack_public_path__ + "static/hw_ff_neopixel_schem-0b34a4f94d76a7aed78598219d0ed016.png";